import { AiOutlineCheckCircle } from "react-icons/ai";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import '../container/sidebar.css'
import i18n from "../../translations/I18n";

const obj = {

    tb1_header: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-white'>카테고리</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>설명</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>서비스</p>",
            },

        ]
    },
    tb1_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Event Sourcing</p>",
            },
            {
                title: "<p class='typo-14'>이벤트중심의 아키텍쳐구축, 대용량 분산시스템, Event Store 운영, 서버리스형</p>",
            },
            {
                title: "<p class='typo-14'>Event Sourcing</p>",
            },

        ],
        row_2: [
            {
                rowSpan: "4",
                title: "<p class='typo-14 typo-medium typo-black'>Identity and Access Management</p>",
            },
            {
                title: "<p class='typo-14'>Identity Provider 운영과 클라이언트의 ID관리및 식별과 인증수행</p>",
            },
            {
                title: "<p class='typo-14'>Open ID Connect</p>",
            },


        ],
        row_3: [
            {
                title: "<p class='typo-14'>OAuth Server/Client 구축으로 권한위임과 인가를 통한 Access Control</p>",
            },
            {
                title: "<p class='typo-14'>OAuth</p>",
            },

        ],
        row_4: [
            {
                title: "<p class='typo-14'>ID 의 그룹화와 조직도 관리</p>",
            },
            {
                title: "<p class='typo-14'>Directory</p>",
            },

        ],
        row_5: [
            {
                title: "<p class='typo-14'>Object 의 읽기, 쓰기, 삭제등의 권한을 Role 에 부여, Access Control List <br> 생성</p>",
            },
            {
                title: "<p class='typo-14'>Role based <br> Access Management</p>",
            },

        ],
        row_6: [
            {
                rowSpan: "4",
                title: "<p class='typo-14 typo-medium typo-black'>Messaging</p>",
            },
            {
                title: "<p class='typo-14'>Publisher 가 메세지를 토픽으로 정의하고 등록, Subscriber 에게 Broadcast</p>",
            },
            {
                title: "<p class='typo-14'>Topics</p>",
            },

        ],
        row_7: [
            {
                title: "<p class='typo-14'>수신된 메세지 토픽을 필터링하여 Subscriber 당 Queue 에 저장해 관리</p>",
            },
            {
                title: "<p class='typo-14'>Queues</p>",
            },

        ],
        row_8: [
            {
                title: "<p class='typo-14'>서버측 어떤 event 를 트리거로 등록해 외부 End Point 로 Push 전달</p>",
            },
            {
                title: "<p class='typo-14'>Webhooks</p>",
            },

        ],
        row_9: [
            {
                title: "<p class='typo-14'>리눅스 Cron 형식지원으로 어플리케이션과 Process 에서 사용</p>",
            },
            {
                title: "<p class='typo-14'>Scheduler</p>",
            },

        ],
        row_10: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Web RPC</p>",
            },
            {
                title: "<p class='typo-14'>Unary, Streaming (Web Socket: Server / Client Bidirectional),<br> Client Type script (Streaming 용)</p>",
            },
            {
                title: "<p class='typo-14'>WebRPC</p>",
            },

        ],
        row_11: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Long-running</p>",
            },
            {
                title: "<p class='typo-14'>Event Sourcing 내 모듈 CUD 의 비동기 작동으로 서버응답을 별도로 <br> 하고 페이지전환</p>",
            },
            {
                title: "<p class='typo-14'>Long-running</p>",
            },

        ],
        row_12: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Storage (S3)</p>",
            },
            {
                title: "<p class='typo-14'>Cloud 내 생성되는 모든 업로드된 파일들을 Object Storage 에 직접저장</p>",
            },
            {
                title: "<p class='typo-14'>Core Storage</p>",
            },

        ],
        row_13: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Email</p>",
            },
            {
                title: "<p class='typo-14'>Cloud 내 Outgoing E-mail 대량발송과 Reporting Dashboard 제공</p>",
            },
            {
                title: "<p class='typo-14'>Vora Email</p>",
            },

        ],
        row_14: [
            {
                rowSpan: "2",
                title: "<p class='typo-14 typo-medium typo-black'>Process(Workflow)</p>",
            },
            {
                title: "<p class='typo-14'>업무자동화, 자동상태변경, 담당자에 자동업무전달</p>",
            },
            {
                title: "<p class='typo-14'>Business Process</p>",
            },

        ],
        row_15: [
            {
                title: "<p class='typo-14'>발송되는 Email/SMS 를 통해 연결된 Site 내 클릭에 따른 자동 프로세스</p>",
            },
            {
                title: "<p class='typo-14'>Journey Process</p>",
            },

        ],
        row_16: [
            {
                rowSpan: "2",
                title: "<p class='typo-14 typo-medium typo-black'>Rule</p>",
            },
            {
                title: "<p class='typo-14'>트리거로 자동실행되어 Criteria 의 True / False 에 따른 액션</p>",
            },
            {
                title: "<p class='typo-14'>Automation Rule</p>",
            },

        ],
        row_17: [
            {
                title: "<p class='typo-14'>룰에 따른 담당자 자동할당</p>",
            },
            {
                title: "<p class='typo-14'>Assignment Rule</p>",
            },

        ],
        row_18: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Rate Limiting</p>",
            },
            {
                title: "<p class='typo-14'>불안정하고 예측불가한 클라이언트 요청이 급증하는 것에 대한 어플리케이션 보호</p>",
            },
            {
                title: "<p class='typo-14'>Rate Limiting</p>",
            },

        ],
        row_19: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Simple URL shortner</p>",
            },
            {
                title: "<p class='typo-14'>긴 URL 을 짧은 URL 로 개인별 변환되며 받는이 식별과 레포팅 제공</p>",
            },
            {
                title: "<p class='typo-14'>SUS</p>",
            },

        ]
    },

    tb2_header: {
        row_1: [
            {
                title: "",
            },
            {
                title: "",
            },

        ]
    },
    tb2_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Identity (식별)</p>",
            },
            {
                title: "<p class='typo-14'>구성원(Principal), 신원(Id) 제시 - 사용자명, 계정번호</p>",
            },

        ],
        row_2: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Authentication (인증)</p>",
            },
            {
                title: "<p class='typo-14'>제시된 신원이 올바른지 증명 - 패스워드, 생체인식, 스마트카드 등</p>",
            },

        ],
        row_3: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Authorization (인가)</p>",
            },
            {
                title: "<p class='typo-14'>특정 객체(Object)에 대해 접근(Access)을 허용하는 과정</p><p class='typo-14'>-- 접근제어목록 (ACL : Access Control List)</p>",
            },

        ],
        row_4: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Access Control (접근제어)</p>",
            },
            {
                title: "<p class='typo-14'>식별 -> 인증 -> 인가를 통과한 유저에게 특정시스템이나 정보에 접근하도록 통제</p><p class='typo-14'>접근제어유형 : 여러 유형중 RBAC (Role Based Access Control) 를 지원</p>",
            },

        ],
        row_5: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>RBAC</p>",
            },
            {
                title: "<p class='typo-14'>Principal(구성원)에게 리소스(Resource)에 대한 Role을 부여하고,</p><p class='typo-14'>미리 정해진 Role에 리소스별 Permission 부여.</p><p class='typo-14'> Permission : Write / Delete / Update / List / Get</p>",
            },

        ],
        row_6: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>IdP (ID 공급자)</p>",
            },
            {
                title: "<p class='typo-14'>Identity Provider, 디지털 ID 생성, 저장, 관리.</p><p class='typo-14'>사용자를 직접 인증하거나, 타사 서비스공급자(SP)에 인증제공 (Google / Facebook 등)</p>",
            },

        ],
    },

    tb3_header: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-white'>구분</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Access Token (OAuth)</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>ID Token (OIDC)</p>",
            },
        ]
    },
    tb3_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>리소스 접근권한</p>",
            },
            {
                title: "",
                icon: <AiOutlineCheckCircle className="icon-check" />,
            },
            {
                title: "",
                icon: <AiOutlineCloseCircle className="icon-close" />,
            },
        ],
        row_2: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>사용자 신원정보</p>",
            },
            {
                title: "",
                icon: <AiOutlineCloseCircle className="icon-close" />,
            },
            {
                title: "",
                icon: <AiOutlineCheckCircle className="icon-check" />,
            },
        ],
    },

    tb4_header: {
        row_1: [
            {
                title: "항목",
            },
            {
                title: "내용",
            },
            {
                title: "가격(원)",
            },
        ]
    },
    tb4_content: {
        row_1: [
            {
                title: "API 요청",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "",
            },
            {
                title: "이후 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
    },
    tb5_header: {
        row_1: [
            {
                title: "항목",
            },
            {
                title: "내용",
            },
            {
                title: "가격(원)",
            },
        ]
    },
    tb5_content: {
        row_1: [
            {
                title: "Event Store",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "",
            },
            {
                title: "이후 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
    },

    tb6_header: {
        row_1: [
            {
                title: "항n",
            },
            {
                title: "건 (월비용)",
            },
            {
                title: "가격(원)",
            },

        ]
    },
    tb6_content: {
        row_1: [
            {
                title: "클라우드 내부간 Push",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },

        ],
        row_2: [
            {
                rowSpan: "2",
                title: "외부 Push",
            },
            {
                title: "백만 건까지",
            },
            {
                title: "00 원",
            },

        ],
        row_3: [
            {
                title: "이후 십만건당",
            },
            {
                title: "1,000 원",
            },

        ],
    },

    tb7_header: {
        row_1: [
            {
                Cols50: "True",
                title: "<p class='typo-14 typo-medium typo-white'>일반적인 방식</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Long-running 방식</p>",
            },
        ],
    },
    tb7_content: {
        row_1: [
            {
                bold: "False",
                title: "<p class='typo-14'>모든 코드는 동기적으로 작동.</p><p class='typo-14'>동기적은 코드가 순서대로 실행되며, 이전코드의 실행이 끝날때까지 기다림.</p>",
            },
            {
                title: "<p class='typo-14'>코드를 비동기로 처리하면, 서버내 백그라운드에서 작업을 처리</p><p class='typo-14'> 작업이 끝날때까지 기다리지 않고 다음코드를 실행</p>",
            },
        ],
    },

    tb8_header: {
        row_1: [
            {
                title: "항옥",
            },
            {
                title: "API 사용건",
            },
            {
                title: "웹 접속건",
            },
            {
                title: "가격(원)",
            },
        ],
    },
    tb8_content: {
        row_1: [
            {
                title: "클라우드 사용고객",
            },
            {
                title: "________________",
            },
            {
                title: "_______ /월 건당",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "외부 - Vora Works",
            },
            {
                title: "________________",
            },
            {
                title: "_______ /월 건당",
            },
            {
                title: "00 원",
            },
        ],
    },

    tb9_header: {
        row_1: [
            {
                title: "&nbsp;",
            },
            {
                title: "Topic",
            },
            {
                title: "Queue",
            },
            {
                title: "Channel",
            },
        ],
    },
    tb9_content: {
        row_1: [
            {
                title: "Delivery",
            },
            {
                title: "<div style='text-align:center'>At Least Once (Exactly Once) <br> <span style='color: #48A7FC; font-size: 14px'>(Committing Offset 방식)</span> <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>"
            },
            {
                title: "<div style='text-align:center'>At Least Once (Exactly Once) <br> <span style='color: #48A7FC; font-size: 14px'>(Ack Reply 방식)</span> <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>"
            },
            {
                title: "<div style='text-align:center'>At Most Once</div>",
            }
        ],
        row_2: [
            {
                title: "Storage",
            },
            {
                title: "<div style='text-align:center'>Disk</div>",
            },
            {
                title: "<div style='text-align:center'>Disk</div>",
            },
            {
                title: "<div style='text-align:center'>In Memory</div>",
            },
        ],
        row_3: [
            {
                title: "Ordering",
            },
            {
                title: "<div style='text-align:center'>순서보장</div>",
            },
            {
                title: "<div style='text-align:center'>순서보장안함</div>",
            },
            {
                title: "<div style='text-align:center'>X</div>",
            },
        ],
        row_4: [
            {
                title: "Consumer",
            },
            {
                title: "<div style='text-align:center'>Pub / Sub</div>",
            },
            {
                title: "<div style='text-align:center'>1:1</div>",
            },
            {
                title: "<div style='text-align:center'>Fan Out (Broadcast)</div>",
            },
        ],
    },
    tb10_header: {
        row_1: [
            {
                Cols50: "True",
                title: "Pull"
            },
            {
                title: "Push"
            },
        ],
    },
    tb10_content: {
        row_1: [
            {
                bold: "False",
                title: "<div style='text-align:'>Streaming Pull 지원. <br> Consumer 가 API 를 호출해서 Message 를 가져감.</div>"
            },
            {
                title: "<div style='text-align:'>Worker가 Message를 받아 GRPC Unary나 URL Get/Post를 보냄.</div>"
            }
        ]
    },
};


export default obj;